import React from 'react';

import {
  BaseAPI,
} from '../utils/BaseAPI';

import Alert from './Alert';

export default function SubmissionForm(props: {
  program: SEEIProgram|undefined;
  repaymentDetails: RepaymentDetail[],
  loanTerm: number,
  interestRate: number,
  financedAmount: number|undefined,
  totalInterest: number|undefined,
  deposit: number,
  repayment: number|undefined,
  onCancel: () => void;
}) {

  const [fullName, setFullName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [phone, setPhone] = React.useState('');
  const [note, setNote] = React.useState('');
  const [formError, setFormError] = React.useState('');
  const [submitInProgress, setSubmitInProgress] = React.useState(false);
  const [dataSubmitted, setDataSubmitted] = React.useState(false);


  const onSubmit = async () => {
    setSubmitInProgress(true);
    setDataSubmitted(false);

    const api = new BaseAPI();
    let success = false;

    const postData = {
      full_name: fullName,
      email: email,
      phone: phone,
      note: note,
      program: props.program,
      loan_term: props.loanTerm,
      repayment_details: props.repaymentDetails,
      financed_amount: props.financedAmount,
      total_interest: props.totalInterest,
      deposit: props.deposit,
      repayment: props.repayment,
      interest_rate: props.interestRate,
    }

    setFormError('');
    try {
      const [result, response, error] = await api.post(postData, `v1/submission/`);
      success = result.success;
      if (success) {
        setSubmitInProgress(false);
        setDataSubmitted(true);
      }
      else {
        setFormError(result.message ? result.message : 'Error submitting your data. Please try again. Contact us if the issue persist.');
        setSubmitInProgress(false);
      }
      console.log('result', result)
    } catch (e) {
      console.log(e);
      setFormError(`${(e as Error).name}: ${(e as Error).message}`);
      setSubmitInProgress(false);
    }
  };


  return (
    <form
      className="space-y-3"
      onSubmit={(e) => {
        e.preventDefault();
        if (submitInProgress) return;
        if (dataSubmitted) return;
        onSubmit();
      }}
    >
      <div>
        <label
          className="block text-sm font-medium leading-6 text-gray-900"
        >Full Name</label>
        <input
          type="text"
          value={fullName}
          required
          autoFocus
          onChange={(e) => setFullName(e.target.value)}
          className="block w-full rounded-md border-0 p-1.5 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
        />
      </div>
      <div>
        <label
          className="block text-sm font-medium leading-6 text-gray-900"
        >Email Address</label>
        <input
          type="email"
          value={email}
          required
          onChange={(e) => setEmail(e.target.value)}
          className="block w-full rounded-md border-0 p-1.5 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
        />
      </div>
      <div>
        <label
          className="block text-sm font-medium leading-6 text-gray-900"
        >Phone Number</label>
        <input
          type="tel"
          value={phone}
          required
          onChange={(e) => setPhone(e.target.value)}
          className="block w-full rounded-md border-0 p-1.5 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
        />
      </div>
      <div>
        <label
          className="block text-sm font-medium leading-6 text-gray-900"
        >Note</label>
        <textarea
          rows={4}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          className="block w-full rounded-md border-0 p-1.5 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
        />
      </div>
      {!!formError && <Alert type="error" message={formError} />}
      {!!dataSubmitted && <Alert type="success" title="Your request has been submitted!" message="We will get back to you as soon as possible!" />}
      {!dataSubmitted && <button
        className="flex w-full justify-center rounded-md bg-indigo-600 mb-3 px-3 py-1.5 text-sm font-semibold leading-6 text-white hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        type="submit"
      >{submitInProgress ? 'Submitting...' : 'Submit'}</button>}
      <button
        className="flex w-full justify-center rounded-md bg-gray-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        onClick={(e) => {
          e.preventDefault();
          setDataSubmitted(false);
          props.onCancel();
        }}
      >{dataSubmitted ? "Back" : "Cancel"}</button>
    </form>
  );
}